export default "__VITE_ASSET__BTIIczyD__"